import { useTranslation } from 'react-i18next';
import { S, Icon } from '../regureStyles';

const Filters = ({ search, setSearch, severity, setSeverity, setPage, status, setStatus, type, setType, selected, handleBulkAcknowledge, SIGNAL_LABELS }) => {
  const { t } = useTranslation();
  return (
    <div
      style={{
        padding: '16px 32px',
        borderBottom: `1px solid ${S.borderLight}`,
        display: 'flex',
        gap: 10,
        flexWrap: 'wrap',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.6)',
        flexShrink: 0,
      }}
    >
      {/* Search */}
      <div style={{ position: 'relative', flex: 1, minWidth: 200, maxWidth: 320 }}>
        <div style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)' }}>
          <Icon name='search' color='#94a3b8' size={15} />
        </div>
        <input
          value={search}
          onChange={e => setSearch(e.target.value)}
          placeholder={t('screens.riskSignals.searchPlaceholder')}
          style={{
            width: '100%',
            padding: '9px 12px 9px 36px',
            background: '#fff',
            border: `1px solid ${S.borderLight}`,
            borderRadius: 10,
            fontSize: 13,
            color: S.textPrimary,
            outline: 'none',
            fontFamily: 'inherit',
            boxSizing: 'border-box',
          }}
        />
      </div>

      {/* Severity */}
      <select
        value={severity}
        onChange={e => {
          setSeverity(e.target.value);
          setPage(1);
        }}
        style={{
          padding: '9px 12px',
          background: '#fff',
          border: `1px solid ${S.borderLight}`,
          borderRadius: 10,
          fontSize: 13,
          color: S.textSecondary,
          cursor: 'pointer',
          outline: 'none',
        }}
      >
        <option value='all'>{t('screens.riskSignals.allSeverities')}</option>
        <option value='critical'>{t('screens.riskSignals.sevCritical')}</option>
        <option value='high'>{t('screens.riskSignals.sevHigh')}</option>
        <option value='medium'>{t('screens.riskSignals.sevMedium')}</option>
        <option value='low'>{t('screens.riskSignals.sevLow')}</option>
      </select>

      {/* Status */}
      <select
        value={status}
        onChange={e => {
          setStatus(e.target.value);
          setPage(1);
        }}
        style={{
          padding: '9px 12px',
          background: '#fff',
          border: `1px solid ${S.borderLight}`,
          borderRadius: 10,
          fontSize: 13,
          color: S.textSecondary,
          cursor: 'pointer',
          outline: 'none',
        }}
      >
        <option value='all'>{t('screens.riskSignals.allStatuses')}</option>
        <option value='active'>{t('screens.riskSignals.statusActive')}</option>
        <option value='acknowledged'>{t('screens.riskSignals.statusAcknowledged')}</option>
        <option value='dismissed'>{t('screens.riskSignals.statusDismissed')}</option>
        <option value='resolved'>{t('screens.riskSignals.statusResolved')}</option>
      </select>

      {/* Type */}
      <select
        value={type}
        onChange={e => {
          setType(e.target.value);
          setPage(1);
        }}
        style={{
          padding: '9px 12px',
          background: '#fff',
          border: `1px solid ${S.borderLight}`,
          borderRadius: 10,
          fontSize: 13,
          color: S.textSecondary,
          cursor: 'pointer',
          outline: 'none',
        }}
      >
        <option value='all'>{t('screens.riskSignals.allTypes')}</option>
        {Object.entries(SIGNAL_LABELS).map(([k, v]) => (
          <option key={k} value={k}>
            {v}
          </option>
        ))}
      </select>

      {/* Bulk actions */}
      {selected.size > 0 && (
        <button
          onClick={handleBulkAcknowledge}
          style={{
            padding: '9px 16px',
            background: `linear-gradient(135deg, ${S.burgundy}, #722f37)`,
            color: '#fff',
            border: 'none',
            borderRadius: 10,
            fontSize: 13,
            fontWeight: 600,
            cursor: 'pointer',
          }}
        >
          {t('screens.riskSignals.acknowledgeSelected', { count: selected.size })}
        </button>
      )}
    </div>
  );
};

export default Filters;
